import { render, staticRenderFns } from "./SingleProductDashboard.vue?vue&type=template&id=1a0a5255&scoped=true&"
import script from "./SingleProductDashboard.vue?vue&type=script&lang=js&"
export * from "./SingleProductDashboard.vue?vue&type=script&lang=js&"
import style0 from "./SingleProductDashboard.vue?vue&type=style&index=0&id=1a0a5255&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a0a5255",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCol,VDivider,VRow,VSkeletonLoader})
